import { IHttpClient } from '@micro-frontend-react/employee-experience/lib/IHttpClient';
import { put, getContext, all, takeLatest, call } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { ApplicationsActionType } from './Applications.action-types';
import { receiveApplications } from './Applications.actions';

export function* fetchApplications(): SagaIterator {
  const httpClient: IHttpClient = yield getContext('httpClient');

  try {
    const { data } = yield call([httpClient, httpClient.request], {
      url: `${__API_BASE_URL__}/applications`,
      resource: __API_RESOURCE__,
    });

    yield put(receiveApplications(data));
  } catch {}
}

export function* applicationsSagas(): SagaIterator {
  yield all([takeLatest(ApplicationsActionType.REQUEST_APPLICATIONS, fetchApplications)]);
}
